import * as React from 'react'
import Popover from '@mui/material/Popover'
import Fade from '@mui/material/Fade'
import { AppointmentsPopoverContent } from './AppointmentsPopoverContent'
import { AppointmentsPopoverProps } from './typing'

export const AppointmentsPopover: React.FC<AppointmentsPopoverProps> = (
  props,
) => {
  const { anchorEl, open, onClose } = props
  const popoverId = open ? 'appointments-popover' : undefined

  return (
    <Popover
      id={popoverId}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{ vertical: 'bottom', horizontal: 0 }}
      elevation={3}
      TransitionComponent={Fade}
    >
      <AppointmentsPopoverContent {...props} />
    </Popover>
  )
}
AppointmentsPopover.displayName = 'AppointmentsPopover'
